import Committed from '../../../common/icons/Committed';
import Neutral from '../../../common/icons/Neutral';
import Uninspired from '../../../common/icons/Uninspired';

export const options = [
  {
    id: 'committed',
    title: 'Committed',
    description: 'I proactively take care of my mouth.',
    icon: Committed,
  },
  {
    id: 'neutral',
    title: 'Neutral',
    description: "It's a habit I maintain.",
    icon: Neutral,
  },
  {
    id: 'uninspired',
    title: 'Uninspired',
    description: 'I have some work to do.',
    icon: Uninspired,
  },
];
